<div *ngIf="statusId !== undefined">
  <app-status-badge [colourScheme]="badgeColourScheme">{{
    StatusName
  }}</app-status-badge>
</div>
